import { useQuery } from '@tanstack/react-query'
import { fetchMetrics } from '../api/metricsClient'

export function useMetricsController() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['metrics'],
    queryFn: ({ signal }) => fetchMetrics(signal),
    refetchInterval: 30000, // Refetch every 30 seconds
  })

  return {
    metrics: data,
    isLoading,
    error,
  }
}
